/**
 * AssignStreamsCtrl controller
 */

// preload drag'n'drop image
const dragndropImg = new window.Image()
dragndropImg.src = require('../shows/img/dragndrop.png')

/**
 * AssignStreamsCtrl controller
 *
 * @class AssignStreamsCtrl
 * @memberof mwApp/subscribers
 * @see mwApp/subscribers
 *
 * @ngdoc controller
 * @name mwApp/subscribers.controller:AssignStreamsCtrl
 */
/* @ngInject */
export default function AssignStreamsCtrl ($http, $uibModalInstance, Subscriber, $scope, alertLiteSvc) {
  const vm = this

  vm.streamType = Subscriber.streamType
  vm.streamItem = Subscriber.streamItem
  vm.fromSearch = false

  /**
   * Network
   *
   * @memberof mwApp/subscribers:AssignStreamsCtrl
   * @type {models.Network}
   */
  vm.pckg = Subscriber.network

  vm.networkId = vm.pckg.id

  vm.assignedStreams = Subscriber[vm.streamType].map(({ [vm.streamItem]: stream }) => stream)

  vm.assignedStreamsIds = vm.assignedStreams.map(({ id }) => id)

  /**
   * Items arrays
   *
   * @memberof mwApp/subscribers.controller:AssignStreamsCtrl
   * @type {Object}
   */
  vm.items = {
    available: {
      name: 'available',
      streams: []
    },
    assigned: {
      name: 'assigned',
      streams: [...vm.assignedStreams]
    }
  }

  switch (vm.streamType) {
    case 'customChannels':
      vm.availableStreamsUrl = `api/networks/${vm.networkId}/channelsets/extra/channels?type=TV`
      vm.customStreamsSetUrl = `api/subscribers/${Subscriber.id}/channels`
      vm.streamsIdsToAssign = 'channelIdsToAssign'
      vm.streamsIdsToRemove = 'channelIdsToRemove'
      vm.content = {
        header: 'TV Channels',
        text: 'Channels'
      }
      break
    case 'customVods':
      vm.availableStreamsUrl = `api/networks/${vm.networkId}/vodsets/vods?available`
      vm.customStreamsSetUrl = `api/subscribers/${Subscriber.id}/vods`
      vm.streamsIdsToAssign = 'vodIdsToAssign'
      vm.streamsIdsToRemove = 'vodIdsToRemove'
      vm.content = {
        header: 'VODs',
        text: 'VODs'
      }
      break
  }

  vm.makeSubmitsPayload = function () {
    const assignedIds = vm.items.assigned.streams.map(({ id }) => id)

    return {
      [vm.streamsIdsToAssign]: assignedIds.filter(id => !vm.assignedStreamsIds.includes(id)),
      [vm.streamsIdsToRemove]: vm.assignedStreamsIds.filter(id => !assignedIds.includes(id))
    }
  }

  /**
   * Filter value for streams sets
   *
   * @memberof mwApp/subscribers:AssignStreamsCtrl
   * @type {string}
   */
  vm.filter = ''

  /**
   * Filter value for assigned streams
   *
   * @memberof mwApp/subscribers:AssignStreamsCtrl
   * @type {string}
   */
  vm.filterAssigned = ''

  /**
   * Table state
   *
   * @memberof mwApp/subscribers:AssignStreamsCtrl
   * @type {Object}
   */
  vm.streamDefaultPagination = {
    q: '',
    page: 0,
    last: false,
    count: 25
  }

  vm.searchContentAvailableParams = angular.copy(vm.streamDefaultPagination)

  /**
   * Load available to assign streams
   *
   * @param {Object} params
   */
  vm.getAvailableStreams = function (params = {}) {
    params.q = vm.filter
    $http.get(vm.availableStreamsUrl, { params })
      .data()
      .then(({ payload }) => {
        if (vm.fromSearch) {
          vm.items.available.streams = []
        }
        vm.items.available.streams = vm.items.available.streams.concat(payload.content.filter(({ id }) => !vm.items.assigned.streams.find(as => as.id === id)))
        vm.searchContentAvailableParams.last = payload.last
      })
      .catch(rejection => alertLiteSvc.alertError(rejection))
  }

  /**
   * get available streams
   */
  vm.getAvailableStreams({ ...vm.streamDefaultPagination })

  /**
   * Update list of streams, and close modal window afterwards
   *
   * @memberof mwApp/subscribers:AssignStreamsCtrl
   */
  vm.submit = function () {
    vm.setDisable()
    $http.put(vm.customStreamsSetUrl, vm.makeSubmitsPayload())
      .then(() => {
        $uibModalInstance.close()
      })
      .catch(rejection => alertLiteSvc.alertError(rejection))
      .finally(vm.unsetDisable)
  }

  /**
   * Handler for scroll event of Available select list
   *
   * @param event
   */
  vm.$timerContentAvailableScroll = 0
  vm.contentCallbackAvailableScroll = (event) => {
    vm.fromSearch = false
    const {
      last
    } = vm.searchContentAvailableParams
    if (!last && event.wheelDelta < 0 && event.currentTarget.scrollTop >= (event.currentTarget.scrollHeight - event.currentTarget.clientHeight) * 0.6) {
      window.clearTimeout(vm.$timerContentAvailableScroll)
      vm.$timerContentAvailableScroll = window.setTimeout(() => {
        vm.searchContentAvailableParams.page++
        vm.getAvailableStreams({ ...vm.searchContentAvailableParams })
      }, 700)
    }
  }

  /**
   * Cancel assigning, close modal window
   *
   * @memberof mwApp/subscribers.controller:AssignStreamsCtrl
   */
  vm.cancel = function () {
    $uibModalInstance.dismiss('cancel')
  }

  // see http://marceljuenemann.github.io/angular-drag-and-drop-lists/demo/#/multi

  /**
   * In the dnd-drop callback, we now have to handle the data array that we
   * sent above. We handle the insertion into the list ourselves. By returning
   * true, the dnd-list directive won't do the insertion itself.
   */
  vm.onDrop = function (list, items, index, event) {
    $scope.form.$setDirty()
    // eslint-disable-next-line no-undef
    event.stopPropagation()
    list.streams = list.streams
      .slice(0, index)
      .concat(items)
      .concat(list.streams.slice(index))
    items.forEach(item => { item.selected = !item.selected })
    return true
  }

  /**
   * dnd-dragging determines what data gets serialized and send to the receiver
   * of the drop. While we usually just send a single object, we send the array
   * of all selected items here.
   */
  vm.getSelected = function (list, link) {
    // eslint-disable-next-line no-undef
    event.stopPropagation()
    link.selected = true
    return list.filter(link => link.selected)
  }
  /**
   * Delete show from showSet
   *
   * @memberof mwApp/subscribers:AssignStreamsCtrl
   */
  vm.deleteStreamFromSet = function (stream) {
    $scope.form.$setDirty()
    // eslint-disable-next-line no-undef
    event.preventDefault()
    stream.selected = false
    vm.items.assigned.streams = vm.items.assigned.streams.filter(ch => ch.id !== stream.id)
    vm.items.available.streams.push(stream)
  }

  /**
   * We set the list into dragging state, meaning the items that are being
   * dragged are hidden. We also use the HTML5 API directly to set a custom
   * image, since otherwise only the one item that the user actually dragged
   * would be shown as drag image.
   */
  vm.onDragstart = function (list, event) {
    list.dragging = true
    if (event.dataTransfer.setDragImage) {
      event.dataTransfer.setDragImage(dragndropImg, 0, 0)
    }
  }

  /**
   * We set the list into dragging state, meaning the items that are being
   * dragged are hidden. We also use the HTML5 API directly to set a custom
   * image, since otherwise only the one item that the user actually dragged
   * would be shown as drag image.
   */
  vm.onDragend = function (list) {
    list.forEach(item => { item.selected = false })
    list.dragging = false
  }

  /**
   * Last but not least, we have to remove the previously dragged items in the
   * dnd-moved callback.
   */
  vm.onMoved = function (list) {
    list.streams = list.streams.filter(item => !item.selected)
  }

  /**
   * Method for filtering streams by name
   *
   * @param {stream} stream
   * @param {String} filter
   * @returns {boolean}
   *
   * @memberof mwApp/subscribers:AssignStreamsCtrl
   */
  $scope.filteredStreams = function (stream, filter) {
    return filter.length > 0
      ? stream.name.toLowerCase().includes(filter.toLowerCase())
      : true
  }

  /**
   * @description Method for filtering assigned streams by name
   * @param {stream} stream
   * @returns {boolean}
   *
   * @memberof mwApp/subscribers:AssignStreamsCtrl
   */
  vm.filteredAssigned = function (stream) {
    return $scope.filteredStreams(stream, vm.filterAssigned)
  }

  $scope.$watch('vm.filter', () => {
    vm.streamDefaultPagination.page = 0
    vm.fromSearch = true
    vm.getAvailableStreams({ ...vm.streamDefaultPagination })
  })
}
/* @ngInject */
